import { Injectable } from '@angular/core';
import { SocketMiddlewareService } from './socket-middleware.service';
import { LibraryEvents } from 'icreate/common/io-event/websocket-message';

@Injectable({
    providedIn: 'root',
})
export class LibrarySocketService {
    constructor(private socketService: SocketMiddlewareService) {}

    libraryCreated$() {
        return this.socketService.receiveMessageObserver(LibraryEvents.LIBRARY_CREATED);
    }

    libraryUpdated$() {
        return this.socketService.receiveMessageObserver(LibraryEvents.LIBRARY_UPDATED);
    }

    libraryDeleted$() {
        return this.socketService.receiveMessageObserver(LibraryEvents.LIBRARY_DELETED);
    }
}
